import React, { useEffect, useRef } from 'react';

const ShopBanner = () => {
  const canvasRef = useRef(null);
  const animRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let t = 0;

    const waves = [
      { amp: 22, freq: 0.012, speed: 0.018, yBase: 0.55, color: 'rgba(30,100,220,0.25)', phase: 0 },
      { amp: 18, freq: 0.016, speed: 0.024, yBase: 0.62, color: 'rgba(20,140,255,0.20)', phase: 1.2 },
      { amp: 26, freq: 0.010, speed: 0.014, yBase: 0.68, color: 'rgba(0,80,200,0.30)',   phase: 2.4 },
      { amp: 14, freq: 0.020, speed: 0.030, yBase: 0.75, color: 'rgba(60,160,255,0.18)', phase: 0.6 },
      { amp: 30, freq: 0.008, speed: 0.010, yBase: 0.80, color: 'rgba(10,60,180,0.35)',  phase: 3.1 },
      { amp: 20, freq: 0.014, speed: 0.020, yBase: 0.88, color: 'rgba(0,40,140,0.45)',   phase: 1.8 },
      { amp: 16, freq: 0.018, speed: 0.022, yBase: 0.95, color: 'rgba(5,30,120,0.55)',   phase: 0.9 },
    ];

    const resize = () => {
      const wrap = canvas.parentElement;
      canvas.width  = wrap.offsetWidth;
      canvas.height = wrap.offsetHeight;
    };

    resize();
    window.addEventListener('resize', resize);

    const drawWave = (w) => {
      const W = canvas.width;
      const H = canvas.height;
      ctx.beginPath();
      ctx.moveTo(0, H);
      for (let x = 0; x <= W; x += 3) {
        const y =
          w.yBase * H +
          Math.sin(x * w.freq + t * w.speed + w.phase) * w.amp +
          Math.sin(x * w.freq * 0.6 + t * w.speed * 1.3 + w.phase + 1) * w.amp * 0.4;
        ctx.lineTo(x, y);
      }
      ctx.lineTo(W, H);
      ctx.closePath();
      ctx.fillStyle = w.color;
      ctx.fill();
    };

    const drawCaustics = () => {
      const W = canvas.width;
      const H = canvas.height;
      for (let i = 0; i < 12; i++) {
        const cx = (Math.sin(t * 0.008 + i * 0.9) * 0.5 + 0.5) * W;
        const cy = (Math.sin(t * 0.006 + i * 1.3) * 0.5 + 0.5) * H * 0.8 + H * 0.1;
        const r  = 30 + Math.sin(t * 0.012 + i) * 15;
        const grad = ctx.createRadialGradient(cx, cy, 0, cx, cy, r);
        grad.addColorStop(0, 'rgba(120,200,255,0.07)');
        grad.addColorStop(1, 'transparent');
        ctx.beginPath();
        ctx.arc(cx, cy, r, 0, Math.PI * 2);
        ctx.fillStyle = grad;
        ctx.fill();
      }
    };

    const loop = () => {
      const W = canvas.width;
      const H = canvas.height;
      ctx.clearRect(0, 0, W, H);
      drawCaustics();
      waves.forEach(drawWave);
      t++;
      animRef.current = requestAnimationFrame(loop);
    };

    loop();

    return () => {
      cancelAnimationFrame(animRef.current);
      window.removeEventListener('resize', resize);
    };
  }, []);

  const title = 'Shopping';

  const floatItems = [
    { icon: '👗', style: { left: '5%',  top: '12%', '--dur': '5.2s', '--delay': '0s',   '--r': '-12deg' } },
    { icon: '🧸', style: { left: '12%', top: '55%', '--dur': '6.1s', '--delay': '0.8s', '--r': '8deg'   } },
    { icon: '👟', style: { left: '20%', top: '20%', '--dur': '4.8s', '--delay': '1.5s', '--r': '-5deg'  } },
    { icon: '🎀', style: { left: '72%', top: '15%', '--dur': '5.5s', '--delay': '0.3s', '--r': '10deg'  } },
    { icon: '🧢', style: { left: '80%', top: '58%', '--dur': '6.4s', '--delay': '1.1s', '--r': '-8deg'  } },
    { icon: '🪀', style: { left: '88%', top: '22%', '--dur': '4.9s', '--delay': '2.0s', '--r': '15deg'  } },
    { icon: '🎮', style: { left: '5%',  top: '70%', '--dur': '5.8s', '--delay': '1.8s', '--r': '-20deg' } },
    { icon: '👜', style: { left: '90%', top: '72%', '--dur': '5.3s', '--delay': '0.6s', '--r': '5deg'   } },
    
  ];

  const bubbles = [
    { style: { left: '15%', width: '18px', height: '18px', '--bdur': '6s',   '--bdel': '0s'   } },
    { style: { left: '30%', width: '10px', height: '10px', '--bdur': '7.5s', '--bdel': '1.2s' } },
    { style: { left: '50%', width: '14px', height: '14px', '--bdur': '5.8s', '--bdel': '2.5s' } },
    { style: { left: '65%', width: '22px', height: '22px', '--bdur': '8s',   '--bdel': '0.7s' } },
    { style: { left: '80%', width: '12px', height: '12px', '--bdur': '6.5s', '--bdel': '3s'   } },
    { style: { left: '42%', width: '8px',  height: '8px',  '--bdur': '5s',   '--bdel': '1.8s' } },
  ];

  return (
    <div style={{ position: 'relative', overflow: 'hidden', width: '100%' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&display=swap');

        .banner-wrap {
          position: relative;
          width: 100%;
          height: 340px;
          background: #0C3D7A;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .wave-canvas {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
        }

        .float-icon {
          position: absolute;
          font-size: 2rem;
          animation: floatBob var(--dur) var(--delay) ease-in-out infinite;
          opacity: 0.85;
          filter: drop-shadow(0 4px 8px rgba(0,0,80,0.3));
          pointer-events: none;
          z-index: 4;
        }

        @keyframes floatBob {
          0%, 100% { transform: translateY(0px)   rotate(var(--r)) scale(1);    }
          50%       { transform: translateY(-14px) rotate(calc(var(--r) + 6deg)) scale(1.07); }
        }

        .title-group {
          position: relative;
          z-index: 10;
          text-align: center;
        }

        .eyebrow {
          font-family: 'Playfair Display', serif;
          font-size: 11px;
          letter-spacing: 6px;
          text-transform: uppercase;
          color: rgba(255,210,80,0.9);
          margin-bottom: 8px;
        }

        .main-title {
          font-family: 'Playfair Display', serif;
          font-size: 5rem;
          font-weight: 900;
          color: #fff;
          letter-spacing: 2px;
          line-height: 1;
          margin: 0;
          text-shadow: 0 2px 20px rgba(0,60,200,0.5);
        }

        .main-title span {
          display: inline-block;
          animation: letterPop 5s var(--ld, 0s) ease-in-out infinite;
        }

        @keyframes letterPop {
          0%, 40%, 100% { transform: translateY(0);    color: #fff;    }
          20%            { transform: translateY(-6px); color: #FFD64F; }
        }

        .sub-tag {
          margin-top: 10px;
          font-family: 'Playfair Display', serif;
          font-size: 12px;
          letter-spacing: 5px;
          text-transform: uppercase;
          color: rgba(255,255,255,0.4);
        }

        .bubble {
          position: absolute;
          bottom: -20px;
          border-radius: 50%;
          background: rgba(120,200,255,0.15);
          border: 1px solid rgba(150,220,255,0.25);
          animation: riseUp var(--bdur) var(--bdel) ease-in infinite;
          pointer-events: none;
          z-index: 3;
        }

        @keyframes riseUp {
          0%   { transform: translateY(0)      scale(1);   opacity: 0;   }
          10%  { opacity: 0.7; }
          90%  { opacity: 0.3; }
          100% { transform: translateY(-380px) scale(0.6); opacity: 0;   }
        }

        @media (max-width: 600px) {
          .main-title  { font-size: 2.8rem; }
          .banner-wrap { height: 240px; }
        }
      `}</style>

      <div className="banner-wrap">
        {/* Animated wave canvas */}
        <canvas className="wave-canvas" ref={canvasRef} />

        {/* Floating product icons */}
        {floatItems.map((item, i) => (
          <div key={i} className="float-icon" style={item.style}>
            {item.icon}
          </div>
        ))}

        {/* Rising bubbles */}
        {bubbles.map((b, i) => (
          <div key={i} className="bubble" style={b.style} />
        ))}

        {/* Center title */}
        <div className="title-group">
          <div className="eyebrow">✦ Discover &amp; Explore ✦</div>
          <h1 className="main-title" aria-label={title}>
            {title.split('').map((char, i) => (
              <span key={i} style={{ '--ld': `${i * 0.15}s` }}>
                {char}
              </span>
            ))}
          </h1>
          <div className="sub-tag">Fashion · Toys · Lifestyle</div>
        </div>
      </div>
    </div>
  );
};

export default ShopBanner;